import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type UseTabOpts = {
  defaultValue: string; // used only if ?tab is missing
};

export const useTabFromQueryString = ({ defaultValue }: UseTabOpts) => {
  const location = useLocation();
  const history = useHistory();

  const [activeTab, setActiveTab] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const qsTab = params.get('tab');

    if (qsTab) {
      // setting activeTab from current url ?tab
      if (activeTab !== qsTab) {
        return setActiveTab(qsTab);
      }
      return;
    }

    // no ?tab — set default only if provided
    if (defaultValue) {
      params.set('tab', defaultValue);
      const next = {
        pathname: location.pathname,
        search: `?${params.toString()}`,
      };
      history.replace(next);

      setActiveTab(defaultValue);
    } else {
      setActiveTab(null);
    }
  }, [location.pathname, location.search, defaultValue, history, activeTab]);

  return { activeTab };
};
